module.exports = __webpack_public_path__ + "img/xinxijianshe2.c576f66e.png";